import { render, staticRenderFns } from "./territories.vue?vue&type=template&id=50b557a0"
import script from "./territories.vue?vue&type=script&lang=js"
export * from "./territories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports